export default "__VITE_ASSET__qhyz8bY1__"